// 8 preset cyber/neon avatars used across the app.
// If any image fails to load, the UI falls back to initials.

export const PRESET_AVATARS = [
  "https://images.unsplash.com/photo-1570341395883-6a8e5a601d93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxjeWJlcnB1bmslMjBuZW9uJTIwYXZhdGFyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1MDEwNDIxfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/flagged/photo-1579451443170-44b3963c3341?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxjeWJlcnB1bmslMjBuZW9uJTIwYXZhdGFyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1MDEwNDIxfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1530651788726-1dbf58eeef1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxjeWJlcnB1bmslMjBuZW9uJTIwYXZhdGFyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg1MDEwNDIxfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/6940512/pexels-photo-6940512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/8107821/pexels-photo-8107821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1613698808499-f772ccb4f527?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxuZW9uJTIwZ2xvd2luZyUyMHBvcnRyYWl0JTIwZmFjZXxlbnwwfHx8fDE3ODUwMTA0MjF8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/10910595/pexels-photo-10910595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/3285794/pexels-photo-3285794.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export function getInitials(name) {
  if (!name) return "??";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase() || "??";
}
